import React from 'react'
import { makeStyles } from '@material-ui/core'
import SydInput from '../../../../../commonDesign/SydInput'
import SydButton from '../../../../../commonDesign/Button'
import { usePipelineForm } from './PipelineFormContext'
import { usePipelineWorkspace } from './PipelineWorkspaceContext'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.75, 1.5),
    flexWrap: 'wrap'
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0
  },
  label: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    color: 'var(--text-color-main)',
    whiteSpace: 'nowrap'
  },
  input: {
    minWidth: '100px',
    padding: '2px 6px !important',
    minHeight: '22px !important',
    '& input': {
      fontSize: 'var(--font-size-xs) !important',
      padding: '0 !important',
      height: '18px !important',
      lineHeight: '18px !important'
    }
  },
  scopeSelect: {
    minWidth: '100px',
    fontSize: 'var(--font-size-xs) !important',
    padding: '2px 6px',
    paddingRight: '24px',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'var(--tc-input-base)',
    height: '22px',
    lineHeight: '18px',
    fontFamily: 'var(--root-font)',
    color: 'var(--text-color-main)',
    cursor: 'pointer',
    appearance: 'none',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath fill=\'%23666\' d=\'M6 9L1 4h10z\'/%3E%3C/svg%3E")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 6px center',
    '&:focus': {
      outline: '1px solid var(--color-primary-500)',
      borderColor: 'var(--color-primary-500)'
    }
  },
  descriptionField: {
    flex: 1,
    minWidth: '200px'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginLeft: 'auto'
  },
  descriptionInput: {
    width: '100%',
    minHeight: '22px',
    resize: 'none',
    fontFamily: 'var(--root-font) !important',
    padding: '2px 6px',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--font-size-xs)',
    lineHeight: '18px',
    height: '22px',
    backgroundColor: 'var(--tc-input-base)'
  },
  error: {
    color: 'var(--color-error-500)',
    fontSize: 'var(--font-size-xs)',
    marginTop: theme.spacing(0.25),
    marginLeft: theme.spacing(0.5)
  }
}))

function PipelineHeader () {
  const classes = useStyles()
  const {
    displayName, setDisplayName,
    code, setCode,
    description, setDescription,
    scope, setScope,
    validation,
    processing, pipelineId,
    isFormDirty
  } = usePipelineForm()

  const { handleSave, resetPipeline, isWorkspaceDirty } = usePipelineWorkspace()

  const isDirty = isFormDirty || isWorkspaceDirty

  return (
    <div className={classes.header}>
      <div className={classes.field}>
        <span className={classes.label}>Code:</span>
        <SydInput
          size='sm'
          value={code}
          onChange={(e) => setCode(e.target.value)}
          error={!!validation?.code}
          className={classes.input}
          placeholder='pipeline-code'
        />
        {validation?.code && (
          <span className={classes.error}>{validation.code}</span>
        )}
      </div>

      <div className={classes.field}>
        <span className={classes.label}>Name:</span>
        <SydInput
          size='sm'
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          error={!!validation?.displayName}
          className={classes.input}
          placeholder='Pipeline name'
        />
        {validation?.displayName && (
          <span className={classes.error}>{validation.displayName}</span>
        )}
      </div>

      <div className={classes.field}>
        <span className={classes.label}>Scope:</span>
        <select
          className={classes.scopeSelect}
          value={scope}
          onChange={(e) => setScope(e.target.value)}
        >
          <option value='system'>system</option>
          <option value='account'>account</option>
          <option value='client'>client</option>
          <option value='asset'>asset</option>
        </select>
        {validation?.scope && (
          <span className={classes.error}>{validation.scope}</span>
        )}
      </div>

      <div className={`${classes.field} ${classes.descriptionField}`}>
        <span className={classes.label}>Description:</span>
        <input
          type='text'
          className={classes.descriptionInput}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder='Pipeline description...'
        />
      </div>

      <div className={classes.actions}>
        <SydButton
          size='xs'
          variant='secondary'
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            resetPipeline()
          }}
          disabled={!pipelineId || !isDirty}
        >
          Reset
        </SydButton>
        <SydButton
          size='xs'
          variant='primary'
          onClick={handleSave}
          disabled={processing || !isDirty}
          icon='check'
          processing={processing}
        >
          Save
        </SydButton>
      </div>
    </div>
  )
}

export default PipelineHeader
